import { Controller } from '@hotwired/stimulus'
import { mandaPasoDeLaBaja } from 'lib/pasos_de_la_baja'

// Connects to data-controller="encuesta-de-la-baja".
//
// La encuesta del motivo de la baja (US-147-2.4.2, `suscribir_desuscribir/_encuesta_de_la_baja.haml`).
// Al abrir la página no se llama a ningún servicio externo: el Typeform se carga solo al pulsar
// «Responder la encuesta».
//
// El formulario es un «live embed» de Typeform, que se gestiona desde Typeform: su configuración
// (qué formulario, tamaño…) la sirve su API. Se pide aquí y no dejando que lo haga `embed.js` para
// poder añadir la newsletter como campo oculto (`data-tf-hidden`) antes de que se pinte; sin el email.
// Si la API falla, se carga el live embed tal cual, sin el campo oculto.
const API_DEL_EMBED = 'https://api.typeform.com/single-embed/'
const SCRIPT_DEL_EMBED = 'https://embed.typeform.com/next/embed.js'

export default class extends Controller {
  static values = { embed: String, newsletter: String, pasoUrl: String }

  async abre () {
    mandaPasoDeLaBaja(this.pasoUrlValue)
    const contenedor = document.createElement('div')
    contenedor.setAttribute('aria-busy', 'true')
    this.element.replaceChildren(contenedor)

    contenedor.replaceChildren(await this.formulario())
    contenedor.removeAttribute('aria-busy')
    this.cargaEmbed()
  }

  // privados

  async formulario () {
    try {
      const respuesta = await fetch(`${API_DEL_EMBED}${this.embedValue}`)
      const { html } = await respuesta.json()
      const plantilla = document.createElement('template')
      plantilla.innerHTML = html
      const widget = plantilla.content.querySelector('[data-tf-widget]')
      if (!widget) throw new Error('El live embed no trae un widget')

      // Solo el elemento del widget, con sus atributos: nada más de lo que mande la API.
      const formulario = widget.cloneNode(false)
      formulario.setAttribute('data-tf-hidden', this.ocultos(widget.getAttribute('data-tf-hidden')))
      return formulario
    } catch (_error) {
      const formulario = document.createElement('div')
      formulario.setAttribute('data-tf-live', this.embedValue)
      return formulario
    }
  }

  ocultos (deTypeform) {
    const propios = this.newsletterValue ? `newsletter=${this.newsletterValue}` : ''
    return [deTypeform, propios].filter(Boolean).join(',')
  }

  cargaEmbed () {
    if (window.tf?.load) return window.tf.load()

    const script = document.createElement('script')
    script.src = SCRIPT_DEL_EMBED
    document.body.appendChild(script)
  }
}
